import { render, staticRenderFns } from "./AIAssistant.vue?vue&type=template&id=87be354e&scoped=true&"
import script from "./AIAssistant.vue?vue&type=script&lang=ts&"
export * from "./AIAssistant.vue?vue&type=script&lang=ts&"
import style0 from "./AIAssistant.vue?vue&type=style&index=0&id=87be354e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87be354e",
  null
  
)

export default component.exports